import { store } from '@/firebase'
import {
  CollectionName,
  FSForm,
  FSInput,
  generateDocId
} from '@WombatTechnology/nitte-time-lib'

import { compact, isUndefined } from 'es-toolkit/compat'
import {
  collection,
  CollectionReference,
  deleteDoc,
  doc,
  DocumentReference,
  getDocs,
  setDoc
} from 'firebase/firestore'
import { Input } from './forms/input'
import { toData } from './toData'

export class Form {
  static ID_LENGTH = 8
  static EMPTY_NAME = '名前なし'

  constructor(
    readonly teamId: string,
    readonly data: FSForm,
    readonly ref: DocumentReference<FSForm>,
    readonly inputs: Input[]
  ) {}

  static async builds(teamId: string): Promise<Form[]> {
    const qs = await getDocs(Form.collection(teamId))
    const forms = await Promise.all(
      qs.docs.map(async (formDoc) => {
        return this.build(formDoc.ref)
      })
    )
    return compact(forms)
  }

  static async build(ref: DocumentReference<FSForm>): Promise<Form | null> {
    const data = await toData(ref)
    if (isUndefined(data)) {
      return null
    }
    const teamId = ref.parent.parent!.id

    const inputs: Input[] = await Input.builds(Input.collection(teamId, ref.id))
    return new Form(teamId, data, ref, inputs)
  }

  static doc(teamId: string, formId: string) {
    return doc(this.collection(teamId), formId)
  }

  static collection(teamId: string) {
    // TODO: FORM ColectionNameを使う
    return collection(
      store,
      `${CollectionName.Teams}/${teamId}/Forms`
    ) as CollectionReference<FSForm>
  }

  // TODO:
  // FormもInputもidを持たせてsetDocする形にする。
  // そうすることで更新が簡単になる。
  static async set(
    teamId: string,
    formId: string,
    data: FSForm,
    inputs: Omit<FSInput, 'index'>[]
  ) {
    await setDoc(this.doc(teamId, formId), data)

    // 一旦全てのInputを削除
    await this.deleteAllInputs(teamId, formId)

    return Promise.all(
      inputs.map((input: Omit<FSInput, 'index'>, index) => {
        // このタイミングでindexを付与する
        const inputWithIndex: FSInput = { ...input, index } as FSInput
        // NOTE: 同じIDでsetし直すので、一旦削除しても同じdocumentIdとなる。
        return Input.set(teamId, formId, input.id, inputWithIndex)
      })
    )
  }

  private static async deleteAllInputs(teamId: string, formId: string) {
    // 一旦全てのInputを削除
    const oldInputCollection = await getDocs(Input.collection(teamId, formId))
    return Promise.all(oldInputCollection.docs.map((oi) => deleteDoc(oi.ref)))
  }

  get id(): string {
    return this.ref.id
  }

  get title(): string {
    return this.data.title
  }

  async delete() {
    await Promise.all(this.inputs.map((i) => i.delete()))
    await deleteDoc(this.ref)
  }

  async duplicate() {
    // フォームのIDのみ作り直す
    const formId = generateDocId(Form.ID_LENGTH)
    const title = `${this.data.title}のコピー`
    return Form.set(
      this.teamId,
      formId,
      { title },
      this.inputs.map((i) => i.data)
    )
  }
}
